export default {
  // End.vue
  end_thanks_message: 'Thanks for participating!',

  // Error.vue
  error_title: 'Something went wrong',
  error_description: 'An error occurred, please contact us if the error persists.',

  // Error404.vue
  not_found: 'Page not found',
  not_found_more: '',

  // Home.vue
  home_welcome: 'Welcome to this survey',
  home_surveyUuid: 'Fill in a survey identifier',

  // IntroLong.vue
  intro_long_title: 'Introduction Long Questions',
  intro_long_body: '| For the following questions you have {n} seconds to judge if an image is real or fake.',
  btn_long: 'Start with Long Questions',

  // IntroPractise.vue
  intro_practise_title: 'Introduction Practise Questions',
  intro_practise_body:
    'A couple of images will be shown, for each image you must judge if the image is real or fake.\n' +
    '\n' +
    'The first images are used to help you get used to how the system works.',
  btn_practise: 'Start with Practise Questions',

  // IntroShort.vue
  intro_short_title: 'Introduction Short Questions',
  intro_short_body:
    ' For the following questions you have {n} second to judge if an image is real or fake. |' +
    ' For the following questions you have {n} seconds to judge if an image is real or fake.',
  btn_short: 'Start with Short Questions',

  // Submit.vue
  submit_feedback: 'What made it for you immediately clear that an image was a fake?',
  btn_submit: 'Submit',

  // Survey.vue
  welcome: 'Welcome to this survey',
  welcome_msg: 'Thanks that you want to help, fill in your name and age to continue.',
  welcome_msg_more: 'With this survey we want to investigate how easy or how hard it is to create shallow fake' +
    ' images. Shallow fake images are images which look real at first glance, but after looking a bit longer it' +
    ' it clear that the image is a fake. To test this images are shown, first with a short time limit and then' +
    ' with a longer time limit. For each image is asked if the image is real or fake.',
  name: 'Name',
  age: 'Age',
  start: 'Start survey',

  // Question.vue
  make_a_choice: 'Make a choice',
  real: 'Real',
  fake: 'Fake',

  // general
  back: 'Go Back',
  submit: 'Submit',
  offline: 'The service is offline, it is not possible to submit any surveys.',
};
